var{toString:t}=Object.prototype,e=e=>e?.constructor??globalThis[t.call(e).slice(8,-1)]??e;export{e as default};